import type { Module } from 'vuex';
import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import type { IReportsLinksState } from '@/store/modules/report/reports-links/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const reportsLinksModule: Module<IReportsLinksState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
};
